<button *ngIf="featureOneTrustBanner" 
  class="ot-sdk-show-settings" 
  data-automation-id="ot-sdk-btn" 
  tippy="{{ 'cookiePreference' | translate }}" 
  attr.aria-label="{{ 'cookiePreference' | translate }}">
</button>